export default __webpack_public_path__ + "static/media/user-type.7dfa3a27.svg";